import { ChannelJobseekerStatModel } from '../shared/models/channel-jobseeker-stat-model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hr-stats-and-reports-jobseekers',
  templateUrl: './stats-and-reports-jobseekers.component.html',
  styleUrls: ['./stats-and-reports-jobseekers.component.less'],
  standalone: false,
})
export class StatsAndReportsJobseekersComponent implements OnInit {
  @Input()
  public channelJobseekerStats: ChannelJobseekerStatModel[];

  constructor() {}

  ngOnInit() {}
}
